import React from 'react';
import { Navigate } from 'react-router-dom';

const e = React.createElement;

function ProtectedRoute({ children }) {
  // 1. Check if the token exists in local storage
  const token = localStorage.getItem('userToken');

  // 2. If there is no token, redirect to Home ('/')
  if (!token) {
    return e(Navigate, { to: '/', replace: true });
  }

  // 3. If they have a token, render the page they asked for
  return children;
}

export default ProtectedRoute;